<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" :model="dioForm" label-width="120px">

            <el-form-item :label="$t('noticelog.email')" prop="address">
                <span>{{ detailObj.address }}</span>
            </el-form-item>
            <el-form-item :label="$t('noticelog.type')" prop="type">
                <span>{{ typeFn(detailObj.type) }}</span>
            </el-form-item>
            <el-form-item :label="$t('noticelog.send_status')" prop="status">
                <span>{{ statusFn(detailObj.status) }}</span>
            </el-form-item>
            <el-form-item :label="$t('noticelog.send_time')" prop="sendTime">
                <span> {{ $timetransition(detailObj.sendTime) }}</span>
            </el-form-item>
            <el-form-item :label="$t('noticelog.mail_content')" prop="content">
                <span>{{ detailObj.content }}</span>
            </el-form-item>
        </el-form>
    </modal>
</template>

<script>
export default {
    props: ['isShow', 'title', 'detailObj'],
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow
            },
            set: function (val) {
                this.$emit('update:isShow', val);//可以优化成model  或者minx
            }
        },
    },
    data() {
        return {
            dioForm: {}
        }
    },
    methods: {
        statusFn(status) {
            return status === 1 ? this.$t('noticelog.send_success') : this.$t('noticelog.send_fail')
        },
        typeFn(status) {
            return status === 1 ? this.$t('noticelog.type_alarm') : this.$t('noticelog.type_captcha')
        }
    }
}
</script>

<style></style>
